"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _getHeaders = require("./getHeaders");
Object.keys(_getHeaders).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getHeaders[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getHeaders[key];
    }
  });
});
var _getBreadcrumbs = require("./getBreadcrumbs");
Object.keys(_getBreadcrumbs).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getBreadcrumbs[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getBreadcrumbs[key];
    }
  });
});
var _getTopBannerAndIntroTextData = require("./getTopBannerAndIntroTextData");
Object.keys(_getTopBannerAndIntroTextData).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getTopBannerAndIntroTextData[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getTopBannerAndIntroTextData[key];
    }
  });
});
var _types = require("./types");
Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _types[key];
    }
  });
});
//# sourceMappingURL=index.js.map